import {MutationTree} from 'vuex';
import {MessageState} from '@/store/modules/message/index';
import {MessageModel} from '@/models/Message.model';

export const mutations: MutationTree<MessageState> = {

    setMessages: (state, messages: MessageModel[]) => {
        state.messages = messages;
    },

};
